import React, { forwardRef } from 'react';
import './styles.scss';

function ItsmInputComponent(props, ref) {

    return <div className={`itsm-input ${props.className}`} ref={ref}>
        <span className="itsm-input-title">{props.label}</span>
        <div className="itsm-input-body">
            {props.children}
        </div>
    </div>
}

export default forwardRef(ItsmInputComponent)